import React from 'react';
import {withDynamicComponents} from 'higher-order-components';
import PhotogalleryItem from '../../containers/photogallery-item';
import PhotoInfo from '../../containers/photo-info';

const PhotogalleryItemBlock = props => <PhotogalleryItem {...props} />;
PhotogalleryItemBlock.displayName = 'PhotogalleryItem';

export default withDynamicComponents({
  componentWhitelist: [
    PhotoInfo,
  ],
  mapInputToOutput: [
    ['photoInfo', 'photoInfo'],
  ],
})(PhotogalleryItemBlock);



// WEBPACK FOOTER //
// ./src/blocks/photogallery-item/index.jsx